<template>
	
	<EbLabel :forId="uid" :class="{ active: isChecked }" class="eb-toggle-button" :text="label" :labelAfter="labelAfter">
		<input :id="uid" role="switch" type="checkbox" :disabled="disabled" @change="onInput($event.target.checked)" :aria-controls="controls" :aria-expanded="expanded" :name="name" :value="value" />
		<span class="eb-toggle-switch">
			<span class="fa fa-solid fa-check"></span>
		</span>
	</EbLabel>
	
</template>

<script>
export default {
	name: "EbSwitch",
	status: "ready",
	release: "1.0.0",
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: null,
		},
		value: {
			default: false
		},
		controls: {
			type: String,
			default: null
		},
		expanded: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			labelAfter: true,
			uid: null
		}
	},
	mounted() {
		this.uid = `uid_${this._uid}`
	},
	computed: {
		isChecked: function() {
			return this.value
		}
	},
	methods: {
		onInput(value) {
			this.$emit("input", value)
		}
	},	
}
</script>